import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import {
  ModalContainerStyled,
  ModalContentStyled,
  ModalFooterStyled,
  ModalHeader,
  MuiButton,
} from "@ryde/controls";
import { IDialogContainerProps } from "@ryde/shared";

type IDialogsInfoProps = IDialogContainerProps & {
  title: string;
  text: string;
  confirmationLabel?: string;
};

export const DialogsInfo = ({
  title,
  text,
  confirmationLabel,
  onClose,
}: IDialogsInfoProps): ReactElement => {
  const { t } = useTranslation();
  confirmationLabel = confirmationLabel ?? t(`general.OK`);

  return (
    <ModalContainerStyled>
      <ModalHeader onClose={onClose}>{title}</ModalHeader>
      <ModalContentStyled $showContent>{text}</ModalContentStyled>
      <ModalFooterStyled>
        <MuiButton onClick={onClose} e2eData="ok-modal-button">
          {confirmationLabel}
        </MuiButton>
      </ModalFooterStyled>
    </ModalContainerStyled>
  );
};
